/// <reference path="../../services/word.service.js" />
const mod = require('../../bahabot.module.js')

/**
 * @param {WordService} WordService
 */
function bbWordController(WordService, $scope, $q) {
    this.svc = WordService;

    this.words = [];
    this.loading = false;
    this.error = null;
    
    this.editedWord = null;
    this.deletedWord = null;
    this.createdWord = null;

    this.createError = null;
    this.deleteError = null;
    this.editError = null;

    this.startRequest = () => {
        this.loading = true;
        this.error = null;
        this.createError = null;
        this.deleteError = null;
        this.editError = null;
    }

    this.get = () => {
        this.startRequest();
        WordService.get()
            .then(r => {
                this.words = r;
            })
            .catch(e => {
                this.error = e.data.error;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    this.createWord = () => {
        this.createdWord = {
            word: "",
            ignoreSpaces: false
        };
    }

    this.createWordCommit = () => {
        this.startRequest();
        WordService.post(this.createdWord)
            .then(() => {
                this.dismiss();
            })
            .catch((e) => {
                this.createError = e.data.error;
            })
            .finally(() => {
                this.loading = false;
            })
    }

    this.editWordCommit = () => {
        this.startRequest();
        WordService.patch(this.editedWord.id, this.editedWord)
            .then(() => {
                this.dismiss();
            })
            .catch((e) => {
                this.editError = e.data.error;
            })
            .finally(() => {
                this.loading = false;
            })
    }

    this.editWord = (word) => {
        this.editedWord = word;
    }

    this.deleteWord = (word) => {
        this.deletedWord = word;
    }

    this.dismiss = () => {
        this.editedWord = null;
        this.deletedWord = null;
        this.createdWord = null;

        this.get();
    }

    this.onDeleteModalAction = (e) => {
        const handler = {
            confirm: () => {
                this.startRequest();
                WordService.delete(this.deletedWord.id)
                    .then(() => {
                        this.dismiss();
                    })
                    .catch((e) => {
                        this.deleteError = e.data.error;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            dismiss: this.dismiss
        };

        handler[e]();
    }

    this.get();
}

mod.component('bbWords', {
    templateUrl: 'tpl/bb-words.component.html',
    bindings: {},
    controller: ["WordService", "$scope", "$q", bbWordController]
});